// src/api/certificates_api.js
// Reads carbon.saving_certificates directly from Supabase — no backend needed.
//
// CRITICAL: select("*") so that the V2 signed fields reach the browser:
//   schema_version, issuer_key_id, assessment_id, data_source, finalized_at
// If any of these are missing, verifyCertificate.js correctly treats the row as
// legacy/non-V2 and verification "fails". They MUST be fetched.

import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  { db: { schema: "carbon" } }
);

/** Full certificate chain, oldest first. Selects ALL columns. */
export async function getCertificates() {
  const { data, error } = await supabase
    .from("saving_certificates")
    .select("*")                                  // ← every column, incl. all V2 signed fields
    .order("chain_index", { ascending: true });

  if (error) throw new Error(error.message);
  return data || [];
}

/** One certificate by id, all columns. */
export async function getCertificate(id) {
  const { data, error } = await supabase
    .from("saving_certificates")
    .select("*")
    .eq("certificate_id", id)
    .maybeSingle();

  if (error) throw new Error(error.message);
  return data;
}

export default getCertificates;
